var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"value":"tab_user","type":"border-card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"保司信息","name":"tab_user"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }